import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * DP278-C6b-2 — the column's state, in one place. The Desk and the project
 * frame both draw the same column, so they read it the same way: once per
 * project, again when a Lifecycle mark is saved or cleared, and never a throw —
 * a failure leaves the column on its own item counts.
 */
export const useColumnState = (projectId) => {
  const [columnState, setColumnState] = useState(null);
  useEffect(() => {
    if (!projectId) return undefined;
    const load = () => axios.get(`${API}/projects/${projectId}/column-state`)
      .then((r) => setColumnState(r.data))
      .catch(() => setColumnState(null));
    load();
    window.addEventListener('km-column-state-changed', load);
    return () => window.removeEventListener('km-column-state-changed', load);
  }, [projectId]);
  return columnState;
};

export default useColumnState;
